import { render, staticRenderFns } from "./ReportingResponsibleBulk.vue?vue&type=template&id=78e7d4f4"
import script from "./ReportingResponsibleBulk.vue?vue&type=script&lang=js"
export * from "./ReportingResponsibleBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports